module.exports = __webpack_public_path__ + "img/s4-notice.5243b28d.png";